// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Variant from "../Data.Variant/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as ProtoVoices_Common from "../ProtoVoices.Common/index.js";
import * as ProtoVoices_Folding from "../ProtoVoices.Folding/index.js";
import * as ProtoVoices_Leftmost from "../ProtoVoices.Leftmost/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorTuple);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromFoldableWithIndex = /* #__PURE__ */ Foreign_Object.fromFoldableWithIndex(Data_Map_Internal.foldableWithIndexMap);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var fromFoldable = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var fromFoldable1 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ProtoVoices_Model.ordSliceId)(Data_Foldable.foldableArray);
var toUnfoldable1 = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var fromFoldable2 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ProtoVoices_Model.ordTransId)(Data_Foldable.foldableArray);
var fromFoldableWithIndex1 = /* #__PURE__ */ Data_Map_Internal.fromFoldableWithIndex(Data_Ord.ordString)(Foreign_Object.foldableWithIndexObject);
var fromFoldable3 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(/* #__PURE__ */ Data_Tuple.ordTuple(Data_Ord.ordString)(Data_Ord.ordString))(Data_Foldable.foldableArray);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show1 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showDoubleOrnament);
var show2 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showRightOrnament);
var show3 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showLeftOrnament);
var show4 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval));
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var show5 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Common.showMBS);
var $$for = /* #__PURE__ */ Data_Traversable["for"](Data_Maybe.applicativeMaybe)(Data_Traversable.traversableArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var parseNotation = /* #__PURE__ */ Data_Pitches_Class.parseNotation(/* #__PURE__ */ Data_Pitches_Class.notationPitch(Data_Pitches_Spelled.notationPitchSInterval));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray);
var sequence1 = /* #__PURE__ */ sequence(Data_Either.applicativeEither);
var bind2 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Either.monadEither));
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT)(Data_Either.monadEither);
var ordRecord = /* #__PURE__ */ Data_Ord.ordRecord();
var ordRecordCons = /* #__PURE__ */ Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)();
var ordRecord1 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons({
    reflectSymbol: function () {
        return "pitch";
    }
})(/* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval)))()({
    reflectSymbol: function () {
        return "id";
    }
})(Data_Ord.ordString));
var ordStartStop = /* #__PURE__ */ ProtoVoices_Model.ordStartStop(ordRecord1);
var ordRecord2 = /* #__PURE__ */ ordRecord(/* #__PURE__ */ Data_Ord.ordRecordCons(/* #__PURE__ */ ordRecordCons({
    reflectSymbol: function () {
        return "right";
    }
})(ordStartStop))()({
    reflectSymbol: function () {
        return "left";
    }
})(ordStartStop));
var fromFoldable4 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordRecord2)(Data_Foldable.foldableArray);
var fromFoldable5 = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordRecord1)(Data_Foldable.foldableArray);
var applicativeStateT = /* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Either.monadEither);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(applicativeStateT);
var on = /* #__PURE__ */ Data_Variant.on();
var tooManyChildrenIsSymbol = {
    reflectSymbol: function () {
        return "tooManyChildren";
    }
};
var on1 = /* #__PURE__ */ on(tooManyChildrenIsSymbol);
var bothChildrenIsSymbol = {
    reflectSymbol: function () {
        return "bothChildren";
    }
};
var on2 = /* #__PURE__ */ on(bothChildrenIsSymbol);
var rightChildIsSymbol = {
    reflectSymbol: function () {
        return "rightChild";
    }
};
var on3 = /* #__PURE__ */ on(rightChildIsSymbol);
var leftChildIsSymbol = {
    reflectSymbol: function () {
        return "leftChild";
    }
};
var on4 = /* #__PURE__ */ on(leftChildIsSymbol);
var fromFoldable6 = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray)(ordRecord2);
var freezeOnlyIsSymbol = {
    reflectSymbol: function () {
        return "freezeOnly";
    }
};
var map3 = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_State_Trans.functorStateT(Data_Either.functorEither));
var freezeLeftIsSymbol = {
    reflectSymbol: function () {
        return "freezeLeft";
    }
};
var horiIsSymbol = {
    reflectSymbol: function () {
        return "hori";
    }
};
var splitRightIsSymbol = {
    reflectSymbol: function () {
        return "splitRight";
    }
};
var splitOnlyIsSymbol = {
    reflectSymbol: function () {
        return "splitOnly";
    }
};
var splitLeftIsSymbol = {
    reflectSymbol: function () {
        return "splitLeft";
    }
};
var evalStateT = /* #__PURE__ */ Control_Monad_State_Trans.evalStateT(Data_Either.functorEither);
var sequence2 = /* #__PURE__ */ sequence(applicativeStateT);
var fromFoldable7 = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var inj = /* #__PURE__ */ Data_Variant.inj();
var inj1 = /* #__PURE__ */ inj(leftChildIsSymbol);
var inj2 = /* #__PURE__ */ inj(rightChildIsSymbol);
var inj3 = /* #__PURE__ */ inj(bothChildrenIsSymbol);
var inj4 = /* #__PURE__ */ inj(tooManyChildrenIsSymbol);
var inj5 = /* #__PURE__ */ inj(freezeLeftIsSymbol);
var inj6 = /* #__PURE__ */ inj(freezeOnlyIsSymbol);
var inj7 = /* #__PURE__ */ inj(splitLeftIsSymbol);
var inj8 = /* #__PURE__ */ inj(splitOnlyIsSymbol);
var inj9 = /* #__PURE__ */ inj(splitRightIsSymbol);
var inj10 = /* #__PURE__ */ inj(horiIsSymbol);
var map4 = /* #__PURE__ */ Data_Functor.map(ProtoVoices_Model.functorStartStop);
var fromFoldable8 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var writeJSONPretty = function (dictWriteForeign) {
    var $337 = Simple_JSON.writeImpl(dictWriteForeign);
    return function ($338) {
        return $foreign.unsafeStringifyPretty($337($338));
    };
};
var stylesToJSON = function (v) {
    var unwrapTransitions = map(lmap(function (v1) {
        return show(v1);
    }));
    var unwrapSlices = map(lmap(function (v1) {
        return show(v1);
    }));
    var unwrapEdge = function (v1) {
        return {
            edge: {
                left: v1.value0.value0,
                right: v1.value0.value1
            },
            style: v1.value1
        };
    };
    return {
        noteStyles: fromFoldableWithIndex(v.notes),
        edgeStyles: map(unwrapEdge)(toUnfoldable(v.edges)),
        sliceStyles: fromFoldable(unwrapSlices(toUnfoldable(v.slices))),
        transStyles: fromFoldable(unwrapTransitions(toUnfoldable(v.transitions))),
        css: v.css,
        staffType: (function () {
            if (v.staff instanceof ProtoVoices_Model.TrebleStaff) {
                return "treble";
            };
            if (v.staff instanceof ProtoVoices_Model.BassStaff) {
                return "bass";
            };
            if (v.staff instanceof ProtoVoices_Model.GrandStaff) {
                return "grand";
            };
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 148, column 16 - line 151, column 28): " + [ v.staff.constructor.name ]);
        })()
    };
};
var stylesFromJSON = function (v) {
    var wrapEdges = function (v1) {
        return new Data_Tuple.Tuple(new Data_Tuple.Tuple(v1.edge.left, v1.edge.right), v1.style);
    };
    var readId = function (constructor) {
        var parse = function (v1) {
            return bind(Data_Maybe.maybe(new Data_Either.Left("cannot parse " + (v1.value0 + "as integer.")))(Data_Either.Right.create)(Data_Int.fromString(v1.value0)))(function (id$prime) {
                return pure(new Data_Tuple.Tuple(constructor(id$prime), v1.value1));
            });
        };
        return traverse(parse);
    };
    return bind(map1(fromFoldable1)(readId(ProtoVoices_Model.SliceId)(toUnfoldable1(v.sliceStyles))))(function (slices) {
        return bind(map1(fromFoldable2)(readId(ProtoVoices_Model.TransId)(toUnfoldable1(v.transStyles))))(function (transitions) {
            return bind((function () {
                if (v.staffType === "treble") {
                    return pure(ProtoVoices_Model.TrebleStaff.value);
                };
                if (v.staffType === "bass") {
                    return pure(ProtoVoices_Model.BassStaff.value);
                };
                if (v.staffType === "grand") {
                    return pure(ProtoVoices_Model.GrandStaff.value);
                };
                return new Data_Either.Left("Unexpected staff type: " + (v.staffType + " (expected treble, bass, or grand)."));
            })())(function (staff) {
                return pure({
                    notes: fromFoldableWithIndex1(v.noteStyles),
                    edges: fromFoldable3(map(wrapEdges)(v.edgeStyles)),
                    slices: slices,
                    transitions: transitions,
                    css: v.css,
                    staff: staff
                });
            });
        });
    });
};
var stripJSONIds = /* #__PURE__ */ map(function (v) {
    return {
        time: v.time,
        notes: map(function (v1) {
            return {
                hold: v1.hold,
                pitch: v1.pitch
            };
        })(v.notes)
    };
});
var splitToJSON = function (v) {
    var unwrap = function (f) {
        return function (v1) {
            return {
                parent: v1.value0,
                children: map(function (v2) {
                    return {
                        child: v2.child,
                        orn: f(v2.orn)
                    };
                })(v1.value1)
            };
        };
    };
    var regToJSON = function (v1) {
        if (v1 instanceof Data_Either.Left) {
            return new Data_Maybe.Just("RootNote");
        };
        if (v1 instanceof Data_Either.Right) {
            return map2(show1)(v1.value0);
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 199, column 15 - line 201, column 26): " + [ v1.constructor.name ]);
    };
    return {
        regular: map(unwrap(regToJSON))(toUnfoldable(v.regular)),
        passing: map(unwrap(map2(show1)))(toUnfoldable(v.passing)),
        fromLeft: map(unwrap(map2(show2)))(toUnfoldable(v.fromLeft)),
        fromRight: map(unwrap(map2(show3)))(toUnfoldable(v.fromRight)),
        unexplained: new Data_Maybe.Just(v.unexplained),
        keepLeft: v.keepLeft,
        keepRight: v.keepRight,
        passLeft: v.passLeft,
        passRight: v.passRight,
        ids: new Data_Maybe.Just(v.ids)
    };
};
var pieceToJSON = /* #__PURE__ */ (function () {
    var noteToJSON = function (v) {
        return {
            hold: v.hold,
            id: v.note.id,
            pitch: show4(v.note.pitch)
        };
    };
    return map(function (v) {
        return {
            time: Data_Either.either(identity)(show5)(v.time),
            notes: map(noteToJSON)(v.notes)
        };
    });
})();
var pieceFromJSON = function (piece) {
    return $$for(piece)(function (slice) {
        return bind1($$for(slice.notes)(function (note) {
            return map2(function (p) {
                return {
                    hold: note.hold,
                    note: {
                        pitch: p,
                        id: note.id
                    }
                };
            })(parseNotation(note.pitch));
        }))(function (notes) {
            return pure1({
                time: ProtoVoices_Common.parseTime(slice.time),
                notes: ProtoVoices_Model.sortNotes(notes)
            });
        });
    });
};
var newTId = function (dictMonad) {
    var bindStateT = Control_Monad_State_Trans.bindStateT(dictMonad);
    var monadStateStateT = Control_Monad_State_Trans.monadStateStateT(dictMonad);
    var discard1 = discard(bindStateT);
    var put = Control_Monad_State_Class.put(monadStateStateT);
    var pure3 = Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(dictMonad));
    return Control_Bind.bind(bindStateT)(Control_Monad_State_Class.get(monadStateStateT))(function (v) {
        return discard1(put({
            nextT: v.nextT + 1 | 0,
            nextS: v.nextS
        }))(function () {
            return pure3(v.nextT);
        });
    });
};
var newTId1 = /* #__PURE__ */ newTId(Data_Either.monadEither);
var newSId = function (dictMonad) {
    var bindStateT = Control_Monad_State_Trans.bindStateT(dictMonad);
    var monadStateStateT = Control_Monad_State_Trans.monadStateStateT(dictMonad);
    var discard1 = discard(bindStateT);
    var put = Control_Monad_State_Class.put(monadStateStateT);
    var pure3 = Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(dictMonad));
    return Control_Bind.bind(bindStateT)(Control_Monad_State_Class.get(monadStateStateT))(function (v) {
        return discard1(put({
            nextT: v.nextT,
            nextS: v.nextS + 1 | 0
        }))(function () {
            return pure3(v.nextS);
        });
    });
};
var newSId1 = /* #__PURE__ */ newSId(Data_Either.monadEither);
var splitFromJSON = function (v) {
    var wrap = function (read) {
        return function (v1) {
            var children$prime = sequence1(map(function (v2) {
                return map1(function (v3) {
                    return {
                        child: v2.child,
                        orn: v3
                    };
                })(read(v2.orn));
            })(v1.children));
            return map1(Data_Tuple.Tuple.create(v1.parent))(children$prime);
        };
    };
    var readRightOrnament = function (v1) {
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "RightNeighbor") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.RightNeighbor.value));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "RightRepeat") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.RightRepeat.value));
        };
        if (v1 instanceof Data_Maybe.Just) {
            return new Data_Either.Left("Expected right ornament type but got " + v1.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return new Data_Either.Right(Data_Maybe.Nothing.value);
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 328, column 23 - line 332, column 29): " + [ v1.constructor.name ]);
    };
    var readPassingOrnament = function (v1) {
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "PassingMid") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.PassingMid.value));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "PassingLeft") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.PassingLeft.value));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "PassingRight") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.PassingRight.value));
        };
        if (v1 instanceof Data_Maybe.Just) {
            return new Data_Either.Left("Expected passing ornament type but got " + v1.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return new Data_Either.Right(Data_Maybe.Nothing.value);
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 321, column 25 - line 326, column 29): " + [ v1.constructor.name ]);
    };
    var readLeftOrnament = function (v1) {
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "LeftNeighbor") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.LeftNeighbor.value));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "LeftRepeat") {
            return new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.LeftRepeat.value));
        };
        if (v1 instanceof Data_Maybe.Just) {
            return new Data_Either.Left("Expected left ornament type but got " + v1.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return new Data_Either.Right(Data_Maybe.Nothing.value);
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 334, column 22 - line 338, column 29): " + [ v1.constructor.name ]);
    };
    var readDoubleOrnament = function (v1) {
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "RootNote") {
            return new Data_Either.Right(new Data_Either.Left(ProtoVoices_Leftmost.RootNote.value));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "FullRepeat") {
            return new Data_Either.Right(new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.FullRepeat.value)));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "FullNeighbor") {
            return new Data_Either.Right(new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.FullNeighbor.value)));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "LeftRepeatOfRight") {
            return new Data_Either.Right(new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.LeftRepeatOfRight.value)));
        };
        if (v1 instanceof Data_Maybe.Just && v1.value0 === "RightRepeatOfLeft") {
            return new Data_Either.Right(new Data_Either.Right(new Data_Maybe.Just(ProtoVoices_Model.RightRepeatOfLeft.value)));
        };
        if (v1 instanceof Data_Maybe.Just) {
            return new Data_Either.Left("Expected double ornament type but got " + v1.value0);
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return new Data_Either.Right(new Data_Either.Right(Data_Maybe.Nothing.value));
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 312, column 24 - line 319, column 37): " + [ v1.constructor.name ]);
    };
    return bind2(lift(map1(fromFoldable4)(sequence1(map(wrap(readDoubleOrnament))(v.regular)))))(function (regular) {
        return bind2(lift(map1(fromFoldable4)(sequence1(map(wrap(readPassingOrnament))(v.passing)))))(function (passing) {
            return bind2(lift(map1(fromFoldable5)(sequence1(map(wrap(readRightOrnament))(v.fromLeft)))))(function (fromLeft) {
                return bind2(lift(map1(fromFoldable5)(sequence1(map(wrap(readLeftOrnament))(v.fromRight)))))(function (fromRight) {
                    return bind2((function () {
                        if (v.ids instanceof Data_Maybe.Just) {
                            return pure2(v.ids.value0);
                        };
                        if (v.ids instanceof Data_Maybe.Nothing) {
                            return bind2(newTId1)(function (left) {
                                return bind2(newSId1)(function (slice) {
                                    return bind2(newTId1)(function (right) {
                                        return pure2({
                                            left: left,
                                            slice: slice,
                                            right: right
                                        });
                                    });
                                });
                            });
                        };
                        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 280, column 10 - line 286, column 34): " + [ v.ids.constructor.name ]);
                    })())(function (ids) {
                        return pure2({
                            regular: regular,
                            passing: passing,
                            fromLeft: fromLeft,
                            fromRight: fromRight,
                            unexplained: Data_Maybe.fromMaybe([  ])(v.unexplained),
                            keepLeft: v.keepLeft,
                            keepRight: v.keepRight,
                            passLeft: v.passLeft,
                            passRight: v.passRight,
                            ids: ids
                        });
                    });
                });
            });
        });
    });
};
var horiFromJSON = function (v) {
    var getDist = on1(Type_Proxy["Proxy"].value)(ProtoVoices_Leftmost.TooManyChildren.create)(on2(Type_Proxy["Proxy"].value)(ProtoVoices_Leftmost.BothChildren.create)(on3(Type_Proxy["Proxy"].value)(ProtoVoices_Leftmost.RightChild.create)(on4(Type_Proxy["Proxy"].value)(ProtoVoices_Leftmost.LeftChild.create)(Data_Variant.case_))));
    var childFromJSON = function (v1) {
        return new Data_Tuple.Tuple(v1.parent, getDist(v1.child));
    };
    return bind2((function () {
        if (v.ids instanceof Data_Maybe.Just) {
            return pure2(v.ids.value0);
        };
        if (v.ids instanceof Data_Maybe.Nothing) {
            return bind2(newTId1)(function (left) {
                return bind2(newSId1)(function (lslice) {
                    return bind2(newTId1)(function (mid) {
                        return bind2(newSId1)(function (rslice) {
                            return bind2(newTId1)(function (right) {
                                return pure2({
                                    left: left,
                                    lslice: lslice,
                                    mid: mid,
                                    rslice: rslice,
                                    right: right
                                });
                            });
                        });
                    });
                });
            });
        };
        throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 342, column 10 - line 350, column 48): " + [ v.ids.constructor.name ]);
    })())(function (ids) {
        return pure2({
            midEdges: {
                regular: fromFoldable6(v.midEdges.regular),
                passing: v.midEdges.passing
            },
            children: fromFoldable5(map(childFromJSON)(v.children)),
            ids: ids,
            unexplained: Data_Maybe.fromMaybe({
                left: [  ],
                right: [  ]
            })(v.unexplained)
        });
    });
};
var freezeToJSON = function (v) {
    return {
        ties: v.ties,
        prevTime: new Data_Maybe.Just(Data_Either.either(identity)(show5)(v.prevTime))
    };
};
var freezeFromJSON = function (v) {
    return new Data_Either.Right({
        ties: v.ties,
        prevTime: Data_Maybe.maybe(new Data_Either.Left(""))(ProtoVoices_Common.parseTime)(v.prevTime)
    });
};
var leftmostFromJSON = /* #__PURE__ */ (function () {
    return on(freezeOnlyIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $339 = map3(ProtoVoices_Leftmost.LMFreezeOnly.create);
        return function ($340) {
            return $339(lift(freezeFromJSON($340)));
        };
    })())(on(freezeLeftIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $341 = map3(ProtoVoices_Leftmost.LMFreezeLeft.create);
        return function ($342) {
            return $341(lift(freezeFromJSON($342)));
        };
    })())(on(horiIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $343 = map3(ProtoVoices_Leftmost.LMHorizontalize.create);
        return function ($344) {
            return $343(horiFromJSON($344));
        };
    })())(on(splitRightIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $345 = map3(ProtoVoices_Leftmost.LMSplitRight.create);
        return function ($346) {
            return $345(splitFromJSON($346));
        };
    })())(on(splitOnlyIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $347 = map3(ProtoVoices_Leftmost.LMSplitOnly.create);
        return function ($348) {
            return $347(splitFromJSON($348));
        };
    })())(on(splitLeftIsSymbol)(Type_Proxy["Proxy"].value)((function () {
        var $349 = map3(ProtoVoices_Leftmost.LMSplitLeft.create);
        return function ($350) {
            return $349(splitFromJSON($350));
        };
    })())(Data_Variant.case_))))));
})();
var modelFromJSON = function (v) {
    var addSliceId = function (v1) {
        return bind2(Data_Maybe.maybe(newSId1)(pure2)(v1.rslice.id))(function (sid) {
            return bind2(Data_Maybe.maybe(newTId1)(pure2)(v1.trans.id))(function (tid) {
                return pure2({
                    trans: {
                        edges: v1.trans.edges,
                        id: tid
                    },
                    rslice: {
                        notes: v1.rslice.notes,
                        id: sid
                    }
                });
            });
        });
    };
    return Data_Function.flip(evalStateT)({
        nextS: 1,
        nextT: 0
    })(bind2(sequence2(map(leftmostFromJSON)(v.derivation)))(function (deriv) {
        return bind2(sequence2(map(addSliceId)(v.topSegments)))(function (topSegments$prime) {
            return bind2(lift(ProtoVoices_Folding.leftmostToReduction(topSegments$prime)(deriv)))(function (v1) {
                return bind2(lift(Data_Maybe.maybe(pure(ProtoVoices_Model.emptyStyles))(stylesFromJSON)(v.styles)))(function (parsedStyles) {
                    return pure2({
                        piece: v1.piece,
                        reduction: v1.reduction,
                        styles: parsedStyles
                    });
                });
            });
        });
    }));
};
var edgesToJSON = function (edges) {
    return {
        regular: fromFoldable7(edges.regular),
        passing: edges.passing
    };
};
var horiToJSON = function (v) {
    var childToJSON = function (v1) {
        var child = (function () {
            if (v1.value1 instanceof ProtoVoices_Leftmost.LeftChild) {
                return inj1(Type_Proxy["Proxy"].value)(v1.value1.value0);
            };
            if (v1.value1 instanceof ProtoVoices_Leftmost.RightChild) {
                return inj2(Type_Proxy["Proxy"].value)(v1.value1.value0);
            };
            if (v1.value1 instanceof ProtoVoices_Leftmost.BothChildren) {
                return inj3(Type_Proxy["Proxy"].value)(v1.value1.value0);
            };
            if (v1.value1 instanceof ProtoVoices_Leftmost.TooManyChildren) {
                return inj4(Type_Proxy["Proxy"].value)(v1.value1.value0);
            };
            throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 213, column 15 - line 217, column 70): " + [ v1.value1.constructor.name ]);
        })();
        return {
            parent: v1.value0,
            child: child
        };
    };
    return {
        midEdges: edgesToJSON(v.midEdges),
        children: map(childToJSON)(toUnfoldable(v.children)),
        ids: new Data_Maybe.Just(v.ids),
        unexplained: new Data_Maybe.Just(v.unexplained)
    };
};
var leftmostToJSON = function (v) {
    if (v instanceof ProtoVoices_Leftmost.LMFreezeLeft) {
        return inj5(Type_Proxy["Proxy"].value)(freezeToJSON(v.value0));
    };
    if (v instanceof ProtoVoices_Leftmost.LMFreezeOnly) {
        return inj6(Type_Proxy["Proxy"].value)(freezeToJSON(v.value0));
    };
    if (v instanceof ProtoVoices_Leftmost.LMSplitLeft) {
        return inj7(Type_Proxy["Proxy"].value)(splitToJSON(v.value0));
    };
    if (v instanceof ProtoVoices_Leftmost.LMSplitOnly) {
        return inj8(Type_Proxy["Proxy"].value)(splitToJSON(v.value0));
    };
    if (v instanceof ProtoVoices_Leftmost.LMSplitRight) {
        return inj9(Type_Proxy["Proxy"].value)(splitToJSON(v.value0));
    };
    if (v instanceof ProtoVoices_Leftmost.LMHorizontalize) {
        return inj10(Type_Proxy["Proxy"].value)(horiToJSON(v.value0));
    };
    throw new Error("Failed pattern match at ProtoVoices.JSONTransport (line 164, column 18 - line 170, column 66): " + [ v.constructor.name ]);
};
var modelToJSON = function (model) {
    var transToJSON = function (v) {
        return {
            edges: edgesToJSON(v.edges),
            id: new Data_Maybe.Just(v.id)
        };
    };
    var sliceToJSON = function (v) {
        return {
            id: new Data_Maybe.Just(v.id),
            notes: map4(map(function (v1) {
                return v1.note;
            }))(v.notes)
        };
    };
    return bind(ProtoVoices_Folding.reductionToLeftmost(model))(function (lm) {
        return pure({
            derivation: map(leftmostToJSON)(lm),
            start: sliceToJSON(model.reduction.start),
            topSegments: map(function (v) {
                return {
                    trans: transToJSON(v.trans),
                    rslice: sliceToJSON(v.rslice)
                };
            })(fromFoldable8(model.reduction.segments)),
            styles: new Data_Maybe.Just(stylesToJSON(model.styles))
        });
    });
};
var addJSONIds = function (piece) {
    var addids = function (s) {
        return Data_Array.mapWithIndex(function (n) {
            return function (note) {
                return {
                    id: "note" + (show(s) + ("." + show(n))),
                    pitch: note.pitch,
                    hold: note.hold
                };
            };
        });
    };
    return Data_Array.mapWithIndex(function (s) {
        return function (slice) {
            return {
                time: slice.time,
                notes: addids(s)(slice.notes)
            };
        };
    })(piece);
};
export {
    unsafeStringifyPretty
} from "./foreign.js";
export {
    pieceToJSON,
    modelToJSON,
    stylesToJSON,
    leftmostToJSON,
    freezeToJSON,
    splitToJSON,
    horiToJSON,
    edgesToJSON,
    pieceFromJSON,
    newTId,
    newSId,
    modelFromJSON,
    leftmostFromJSON,
    freezeFromJSON,
    splitFromJSON,
    horiFromJSON,
    stylesFromJSON,
    addJSONIds,
    stripJSONIds,
    writeJSONPretty
};
